import { apiSahPricePlans } from '~constants/api';

import { get, post, remove } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'sah-price-plans';

const config = [
  { actionType: 'getAll', apiPath: apiSahPricePlans, method: get },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiSahPricePlans}/${params.id}`, method: get },
  { actionType: 'create', apiPath: apiSahPricePlans, method: post },
  { actionType: 'deleteOne', apiPath: (params: Params) => `${apiSahPricePlans}/${params.id}`, method: remove },
];

export const { getAll, getOne, create, deleteOne } = createThunks(typePrefix, config);
